import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { userPermissions } from "./permissions";

export const roleColor = [
  "gray",
  "green",
  "yellow",
  "red",
  "blue",
  "purple",
  "pink",
  "orange",
] as const;

export type RoleColor = (typeof roleColor)[number];

export const UserRoleSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  permissions: zExt.filterToValidArray(createEnum(userPermissions)).default([]),
  team: zExt.objectId(), // Managed Roles are hard coded
  roleColor: createEnum(roleColor).default("gray"),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type CustomUserRole = z.infer<typeof UserRoleSchema>;
